import React from "react";

// Small pill badge used above section headings across the site — a colored dot + tracked-out label.
// Pass `dark` when placing it on a navy/dark background (e.g. Testimonials, CTA bands).
export const Eyebrow = ({ children, color = "#4F9622", dark = false }) => {
  if (dark) {
    return (
      <div className="inline-flex items-center gap-2 text-xs font-bold tracking-widest px-3 py-1.5 rounded-full mb-4 bg-white/10 text-[#8BD835] border border-white/10">
        <span className="w-1.5 h-1.5 rounded-full bg-[#8BD835]" />
        {children}
      </div>
    );
  }
  return (
    <div
      className="inline-flex items-center gap-2 text-xs font-bold tracking-widest px-3 py-1.5 rounded-full mb-4"
      style={{ color, backgroundColor: `${color}1A` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: color }} />
      {children}
    </div>
  );
};

export default Eyebrow;
